<script lang="typescript">
    import Loader from "shared/loader.svelte";
    import Form from "shared/form.svelte";
    import Input from "shared/input.svelte";

    import Switch from "shared/switch.svelte";
    import List from "shared/list.svelte";

    import Sheet from "shared/sheet.svelte";
    import Header from "../components/header.svelte";
    import SectionSubHeader from "../components/section-subheader.svelte";
    import Subtitle2 from "shared/typography/subtitle2.svelte";
    import Caption from "shared/typography/caption.svelte";
    import Button from "shared/button.svelte";
    import DropDown from "shared/dropdown.svelte";

    // remove on production

    import * as ApiService from "../services/api.service";

    let rules: Rule[] = [];
    let jorneys: Journey[] = [];
    let condittions: RuleCondition[] = [];

    let selectedRule: Rule;
    let selectedJourney: Journey;
    let selectedRuleTemp: Rule;
    let selectedOldId: string;
    let inAddingNew = false;
    let isListProcessing = false;
    let inEditMode = false;
    let isFormValid = true;
    let status = "";

    import {
        AnomalyIcon,
        EditIcon,
        EmptyIcon,
        LogoIcon,
        NotificationIcon,
        RemoveIcon,
    } from "../components/icons";
    import { onMount } from "svelte";
    import { RequiredValidation } from "shared/validations/required";

    const onLineSelected = (l: any) => {};
    const addNewLine = (l: any) => {};
    const editLine = (l: any) => {};
    const removeLine = (l: any) => {};

    onMount(async () => {});
</script>

<div class="rules-view">
    <div class="content">
        <Header
            title="WhatsApp Lines"
            subtitle="Configure todas as regras para detectar anomalias no acesso dos funcionários"
        />
        <div class="columns ">
            <!-- List Column -->
            {#if !inEditMode}
                <div class="rows mr-16 list">
                    <SectionSubHeader
                        icon={NotificationIcon}
                        title="Lista de linhas ancoradas"
                    />

                    <Sheet>
                        <div class="buttons">
                            {#if isListProcessing}
                                <div class="status">
                                    <Loader size={36} />
                                    <Subtitle2
                                        text={status}
                                        style="padding: 0 16px;"
                                    />
                                </div>
                            {/if}
                            <Button text="nova regra" on:click={addNewLine} />
                        </div>

                        {#if !isListProcessing}
                            <List
                                on:select={onLineSelected}
                                selected={selectedRule}
                                items={rules}
                            >
                                <div
                                    slot="item"
                                    let:item
                                    let:active
                                    class="list-item"
                                >
                                    <span class="item-icon">
                                        <svelte:component
                                            this={NotificationIcon}
                                            width={24}
                                            height={24}
                                            color="var(--color-level-5)"
                                        />
                                    </span>

                                    <div class="list-info rows">
                                        <Subtitle2
                                            text={item.title}
                                            color={active
                                                ? "var(--color-primary)"
                                                : "var(--color-level-7)"}
                                        />
                                        <Caption
                                            text={item.description}
                                            color="var(--color-level-5)"
                                        />
                                    </div>
                                    <span
                                        class="item-icon"
                                        on:click={() => editLine(item)}
                                    >
                                        <EditIcon
                                            width={24}
                                            height={24}
                                            color="var(--color-level-6)"
                                        />
                                    </span>
                                    <span
                                        class="item-icon"
                                        on:click={() => removeLine(item)}
                                    >
                                        <RemoveIcon
                                            width={24}
                                            height={24}
                                            color="var(--color-level-6)"
                                        />
                                    </span>
                                </div>
                            </List>
                        {/if}
                    </Sheet>
                </div>
            {/if}

            <!-- Time line -->
            <div class="rows timeline">
                <SectionSubHeader icon={NotificationIcon} title="Line Edit" />
                <Sheet style=" width: 100%; padding: 16px;">EDIT</Sheet>
            </div>
        </div>
    </div>
</div>

<style>
    .rules-view {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        /* padding: 0 10%; */
        align-items: center;
        overflow: auto;
    }
    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 0 32px 16px 32px;
    }
    .columns {
        display: flex;
        flex-direction: row;
        /* flex-wrap: wrap; */
        height: 100%;
        overflow: hidden;
    }

    .rows {
        display: flex;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
    }



    .buttons {
        height: 48px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: var(--color-level-2);
    }

    .row {
        grid-template-columns: auto 1fr;
        display: grid;
        column-gap: 16px;
        margin-bottom: 8px;
    }

    .row-one {
        grid-template-columns: auto;
    }
    .row-2 {
        grid-template-columns: 1fr 1fr;
    }
    .row-4 {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .timeline {
        width: auto;
        flex-grow: 1;
    }

    .mr-16 {
        margin-right: 16px;
    }
    /* .ml-16 {
        margin-left: 16px;
    } */

    .list {
        width: 500px;
    }
    .list-info {
        width: 100%;
        justify-content: center;
    }
    .list-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        /* padding: 0 16px; */
        border-bottom: 1px solid var(--color-level-3);
    }

    .item-icon {
        height: 100%;
        padding: 0 16px;
        display: flex;
        align-items: center;
    }
    .item-icon:hover {
        background: var(--color-level-3);
    }

    /* TODO make this a component */
    .status {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 32px;
        align-items: center;
        padding: 0 16px;
    }

    .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
</style>
